import { Component } from '@angular/core';
import { BankAccountHelpConst } from '../const';

@Component({
    selector: 'convfact-bankAccountHelp',
    template: '<app-table [columns]="headerTable" [dataSource]="dataSource"></app-table>',
    standalone: false
})

export class BankAccountHelpComponent {

    dataSource: {swift: string, bank: string}[] = [
        {swift: 'BARCESMM', bank: 'CAIXABANK'},
        {swift: 'BBVAESMM', bank: 'BANCO BILBAO VIZCAYA ARGENTARIA - BBVA'},
        {swift: 'BCOEESMM', bank: 'CAJA RURAL'},
        {swift: 'BCOEESMM', bank: 'CAJA SIETE CAJA RURAL SCC'},
        {swift: 'BKBKESMM', bank: 'BANKINTER'},
        {swift: 'BMARES2M', bank: 'BANCA MARCH SA'},
        {swift: 'BPLCESMM', bank: 'BARCLAYS BANK PLC'},
        {swift: 'BSABESBB', bank: 'BANCO DE SABADELL'},
        {swift: 'BSCHESMG', bank: 'BANCO SANTANDER S.A'},
        {swift: 'BSCHESMM', bank: 'BANCO SANTANDER'},
        {swift: 'CAHMESMM', bank: 'BANKIA'},
        {swift: 'CAIXESBB', bank: 'CAIXABANK'},
        {swift: 'CAZRES2Z', bank: 'IBERCAJA BANCO S A'},
        {swift: 'CITIES2X', bank: 'CITIBANK ESPANA'},
        {swift: 'ESPBESMM', bank: 'BANCO DE ESPANA'},
        {swift: 'EVOBESMM', bank: 'EVO BANCO'},
        {swift: 'INGDESMM', bank: 'ING BANK NV'},
        {swift: 'POPUESMM', bank: 'BANCO POPULAR ESPANOL'},
        {swift: 'UCJAES2M', bank: 'UNICAJA BANCO'}
    ];
  
    headerTable: any[] = BankAccountHelpConst.headerTable;

    constructor(){}
    
}